import PropTypes from 'prop-types';
import React from 'react';

function UserIcon({
  id = '0',
  glyph = 'user',
  name = 'User 1',
  selected = false,
  isActive,
  onClick = () => {},
  onDoubleClick = () => {},
}) {
  return (
    <div
      role="button"
      tabIndex={0}
      title={name}
      className={`users ${selected && 'selected'} ${!isActive && 'inactive'} `}
      onClick={() => onClick(id)}
      onDoubleClick={() => onDoubleClick(id)}
      onKeyPress={() => {}}
    >
      <span className={`user-icon ${glyph}`} />
      <p className="user-name">{name}</p>
    </div>
  );
}

UserIcon.propTypes = {
  id: PropTypes.any,
  glyph: PropTypes.string,
  name: PropTypes.string,
  selected: PropTypes.bool,
  isActive: PropTypes.bool,
  onClick: PropTypes.func,
  onDoubleClick: PropTypes.func,
};

UserIcon.defaultProps = {
  id: '0',
  glyph: 'user',
  name: 'User 1',
  selected: false,
  isActive: false,
  onClick: () => {},
  onDoubleClick: () => {},
};

export default UserIcon;
